import { useEffect, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import {
  format,
  startOfWeek,
  endOfWeek,
  subWeeks,
  addWeeks,
  addDays,
} from 'date-fns'
import { Select } from 'src/components/select'
import { SubjectSelect } from 'src/components/common'
import { useAuth } from 'src/contexts/auth.context'
import { useNotification } from 'src/contexts/notification.context'
import {
  getDashboardLessonsRequest,
  getStudentEvents,
} from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import { times } from 'src/tools'

const HOST = process.env.REACT_APP_API_HOST

export const StudentDashboard = () => {
  const { user, setViewStates } = useAuth()
  const history = useHistory()
  const { date = null } = useParams()
  const { wrapCallback } = useNotification()
  const [startDay, setStartDay] = useState(
    startOfWeek(date ? new Date(date) : new Date()),
  )
  const [endDay, setEndDay] = useState(
    endOfWeek(date ? new Date(date) : new Date()),
  )
  const [data, setData] = useState({})
  const [weekEvents, setWeekEvents] = useState(null)
  const [events, setEvents] = useState([])

  const [curDate, setCurDate] = useState(date)

  const [filter, setFilter] = useState({
    subject_id: null,
    type: null,
    // classroom_id: null,
    // period: 'month',
  })

  const [lessons, setLessons] = useState([])

  useEffect(() => {
    if (Object.keys(data).length === 0) {
      const first = startOfWeek(date ? new Date(date) : new Date())
      const days = times(7).reduce((acc, val) => {
        acc[format(addDays(first, val), 'yyyy-MM-dd')] = []
        return acc
      }, {})
      setData(days)
    }
  }, [data])

  useEffect(() => {
    if (!date) {
      history.push(routes.dashboard.day(format(new Date(), 'yyyy-MM-dd')))
      return
    }
    setCurDate(date)
  }, [date])

  useEffect(() => {
    wrapCallback(async () => {
      if (!user.role_id) return

      const responseLessons = await getDashboardLessonsRequest({
        start_date: format(startDay, 'yyyy-MM-dd'),
        end_date: format(endDay, 'yyyy-MM-dd'),
      })
      setData(responseLessons.data?.items)

      const responseEvents = await getStudentEvents({
        start_date: format(startDay, 'yyyy-MM-dd'),
        end_date: format(endDay, 'yyyy-MM-dd'),
      })

      console.log('responseEvents.data.items', responseEvents.data.items)

      setWeekEvents(responseEvents.data.items)
    })
  }, [startDay, endDay])

  useEffect(() => {
    let less = Array.isArray(data[curDate]?.personal)
      ? data[curDate]?.personal
      : []

    if (Array.isArray(data[curDate]?.classroom)) {
      less = [...less, ...data[curDate]?.classroom]
    }

    if (filter.subject_id) {
      less = less.filter((x) => x.subject_id === filter.subject_id)
    }

    if (filter.type) {
      less = less.filter((x) => Number(x.type) === Number(filter.type))
    }

    setLessons(less)
  }, [curDate, data, filter])

  useEffect(() => {
    if (!weekEvents) return

    console.log('weekEvents2', weekEvents)

    setEvents(weekEvents[curDate]?.events || [])
  }, [curDate, weekEvents])

  useEffect(() => {
    // setStep(user?.view_states?.dashboardTile || 0)
    setViewStates({ dashboardTile: 1 })
  }, [user?.view_states?.dashboardTile])

  const handleChangeCurDate = (val) => () => {
    history.push(routes.dashboard.day(val))
  }

  const handleLeftWeek = () => {
    setStartDay(subWeeks(startDay, 1))
    setEndDay(subWeeks(endDay, 1))
  }

  const handleRightWeek = () => {
    setStartDay(addWeeks(startDay, 1))
    setEndDay(addWeeks(endDay, 1))
  }

  // console.log('lessons', lessons);

  if (user?.view_states?.dashboardTile === 0) {
    return (
      <>
        <h2 className="sectionHb-title">Dashboard</h2>
        <div className="sectionHb-block dashboardHb">
          <div className="sectionHb-block__wrap">
            <h2 className="sectionHb-title">
              Welcome,{' '}
              <span>
                {user.first_name} {user.last_name}
              </span>
            </h2>
            <div className="dashboardHb-img">
              <img src="/account//account/img/dashboard/img-1.svg" alt="" />
            </div>
            {/* <p>Welcome to your <b>Practithink</b> account! <br/>Take tests, learn new things, receive unparalleled awards and certificates! <br/>And find students like you!</p> */}
            <div className="practithinkHb">
              <span className="practithinkHb-title">
                Your Practithink starts here
              </span>
              <div className="row">
                <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                  <Link to="/lessons" className="practithinkHb-wrap">
                    <div className="practithinkHb-ico">
                      <img
                        src="/account//account/img/dashboard/ico-1.svg"
                        alt=""
                      />
                    </div>
                    <span className="practithinkHb-subtitle">Logic games</span>
                  </Link>
                </div>
                <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                  <Link to="/lessons" className="practithinkHb-wrap">
                    <div className="practithinkHb-ico">
                      <img
                        src="/account//account/img/dashboard/ico-2.svg"
                        alt=""
                      />
                    </div>
                    <span className="practithinkHb-subtitle">
                      Start testing
                    </span>
                  </Link>
                </div>
                <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                  <Link to="/lessons" className="practithinkHb-wrap">
                    <div className="practithinkHb-ico">
                      <img
                        src="/account//account/img/dashboard/ico-4.svg"
                        alt=""
                      />
                    </div>
                    <span className="practithinkHb-subtitle">
                      Take a lesson
                    </span>
                  </Link>
                </div>
                <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                  <Link to="/lessons" className="practithinkHb-wrap">
                    <div className="practithinkHb-ico">
                      <img
                        src="/account//account/img/dashboard/ico-3.svg"
                        alt=""
                      />
                    </div>
                    <span className="practithinkHb-subtitle">Find friends</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  console.log('datedate', date)

  const labelDate =
    !date || date === format(new Date(), 'yyyy-MM-dd')
      ? 'Today'
      : format(new Date(date), 'MMM dd')

  return (
    <>
      <div className="sectionHb-top">
        <h2 className="sectionHb-title">Practicing</h2>
        <span className="sectionHb-sub">{labelDate}</span>
      </div>

      <div className="dateBoard">
        <div className="dateBoard-head">
          <div className="dateBoard-head__wrap">
            <div className="dateBoard-slider swiper-container swiper-container-initialized swiper-container-horizontal">
              <div
                className="dateBoard-slider__wrapper swiper-wrapper"
                id="swiper-wrapper-bbe4076749bda4710"
                aria-live="polite"
              >
                {data &&
                  Object.keys(data).map((x) => (
                    <div
                      key={x}
                      className={`dateBoard-slide swiper-slide swiper-slide-visible ${
                        curDate === x ? 'swiper-slide-active' : ''
                      }`}
                      role="group"
                      aria-label="1 / 7"
                      onClick={handleChangeCurDate(x)}
                    >
                      <div className="dateBoard-wrap">
                        {/* <i class="hb-ico dateBoard-ico-1"></i> */}
                        <div className="dateBoard-info">
                          {}
                          <span>{format(new Date(x), 'MMM')}</span>
                          <b>{format(new Date(x), 'dd')}</b>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <span
                className="swiper-notification"
                aria-live="assertive"
                aria-atomic="true"
              />
            </div>
            <div
              onClick={handleRightWeek}
              className="swiper-button-next"
              tabIndex="0"
              role="button"
              aria-label="Next slide"
              aria-controls="swiper-wrapper-bbe4076749bda4710"
              aria-disabled="false"
            />
            <div
              onClick={handleLeftWeek}
              className="swiper-button-prev"
              tabIndex="-1"
              role="button"
              aria-label="Previous slide"
              aria-controls="swiper-wrapper-bbe4076749bda4710"
              aria-disabled="true"
            />
          </div>
        </div>
      </div>

      <div className="sectionHb-block review invites cardsHb">
        <div className="sectionHb-block__wrap">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-6" />
            <div className="col-lg-3 col-md-6 col-6" />
            <div className="col-lg-3 col-md-6 col-6">
              <div className="input-block">
                <SubjectSelect
                  value={filter.subject_id}
                  onChange={(item) => {
                    setFilter({ ...filter, subject_id: item?.value })
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="input-block">
                <Select
                  placeholder="Type"
                  value={filter.type}
                  onChange={(item) => {
                    setFilter({ ...filter, type: item?.value })
                  }}
                  options={[
                    { label: 'ALL', value: null },
                    { label: 'Practices', value: 1 },
                    { label: 'Tests', value: 2 },
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="cardsHb-content">
            {lessons.length <= 0 && (
              <div className="label-none">
                You are all set, you have no practices for {labelDate}!
              </div>
            )}
            <div className="row">
              {lessons.map((x) => (
                <div key={x.id} className="col-md-6">
                  <div className="cardsHb-wrap">
                    {/* <div class="dropHb">
                      <div class="dropHb-top">
                        <i class="hb-ico dots-ico"></i>
                      </div>
                      <div class="dropHb-info">
                        <ul>
                          <li><a data-fancybox="" data-src="#modal-dele" href="javascript:;">
                            <i class="hb-ico trash-ico"></i>
                            Delete
                          </a></li>
                          <li><a href="#">
                            <i class="hb-ico assign-ico"></i>
                            Continue
                          </a></li>
                        </ul>
                      </div>
                    </div> */}
                    <Link
                      to={routes.lessons.queue(x.id)}
                      class="cardsHb-item cardsHb-green"
                    >
                      <div className="cardsHb-info">
                        <span className="cardsHb-title">
                          {x?.subject?.name}
                        </span>
                        <span className="cardsHb-subtitle">
                          {x?.title} by {x?.teacher?.first_name}
                          {x?.teacher?.last_name}
                        </span>
                        {x?.your_score ? (
                          <div className="cardsHb-img">
                            <img src="/account/img/cards/img-1.svg" alt="" />
                          </div>
                        ) : (
                          <div />
                        )}
                      </div>
                      <div className="cardsHb-circle">
                        <div className="cardsHb-circle__row">
                          <div>
                            {x?.your_score
                              ? `${x?.your_score}/${x?.total}`
                              : 'NEW'}
                          </div>
                        </div>
                        <div className="cardsHb-circle__row">
                          {/* <img src="/account/img/cards/ico-1.svg" alt="" /> */}
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
              {/*
              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <div class="dropHb">
                    <div class="dropHb-top">
                      <i class="hb-ico dots-ico"></i>
                    </div>
                    <div class="dropHb-info">
                      <ul>
                        <li><a data-fancybox="" data-src="#modal-dele" href="javascript:;">
                          <i class="hb-ico trash-ico"></i>
                          Delete
                        </a></li>
                        <li><a href="#">
                          <i class="hb-ico assign-ico"></i>
                          Continue
                        </a></li>
                      </ul>
                    </div>
                  </div>
                  <a href="#" class="cardsHb-item cardsHb-green">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Practices name</span>
                      <span class="cardsHb-subtitle">Mrs. Name</span>
                      <div class="cardsHb-img"><img src="/account/img/cards/img-1.svg" alt="" /></div>
                    </div>
                    <div class="cardsHb-circle">
                      <div class="cardsHb-circle__row">
                        <div>100</div>
                      </div>
                      <div class="cardsHb-circle__row">
                      <img src="/account/img/cards/ico-1.svg" alt="" />
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <div class="dropHb">
                    <div class="dropHb-top">
                      <i class="hb-ico dots-ico"></i>
                    </div>
                    <div class="dropHb-info">
                      <ul>
                        <li><a data-fancybox="" data-src="#modal-dele" href="javascript:;">
                          <i class="hb-ico trash-ico"></i>
                          Delete
                        </a></li>
                        <li><a href="#">
                          <i class="hb-ico assign-ico"></i>
                          Continue
                        </a></li>
                      </ul>
                    </div>
                  </div>
                  <a href="#" class="cardsHb-item cardsHb-green2">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Practices name</span>
                      <span class="cardsHb-subtitle">Mrs. Name</span>
                      <div class="cardsHb-img"><img src="/account/img/cards/img-2.svg" alt="" /></div>
                    </div>
                    <div class="cardsHb-circle">
                      10
                    </div>
                    <div class="cardsHb-bar">
                      <span style={{ width: '20%' }}></span>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <div class="dropHb">
                    <div class="dropHb-top">
                      <i class="hb-ico dots-ico"></i>
                    </div>
                    <div class="dropHb-info">
                      <ul>
                        <li><a data-fancybox="" data-src="#modal-dele" href="javascript:;">
                          <i class="hb-ico trash-ico"></i>
                          Delete
                        </a></li>
                        <li><a href="#">
                          <i class="hb-ico assign-ico"></i>
                          Continue
                        </a></li>
                      </ul>
                    </div>
                  </div>
                  <a href="#" class="cardsHb-item cardsHb-blue2">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Test name</span>
                      <span class="cardsHb-subtitle">Mrs. Name</span>
                      <div class="cardsHb-time">
                        <img src="/account/img/cards/img-3.svg" alt="" />
                        <span>1 pm</span>
                      </div>
                    </div>
                    <div class="cardsHb-circle">
                      10
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-blue cardsHb-hover">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Beyond Z</span>
                      <span class="cardsHb-subtitle">Mrs. Name</span>
                      <div class="cardsHb-mes">
                        <p><span>You still have</span>20 unfinished practice(s)</p>
                      </div>
                      <div class="cardsHb-img"><img src="/account/img/cards/img-4.svg" alt="" /></div>
                    </div>
                    <span class="cardsHb-monkey"><img src="/account/img/cards/img-close.svg" alt="" /></span>
                    <div class="cardsHb-circle">
                      <div class="cardsHb-ico"><img src="/account/img/cards/ico-2.svg" alt="" /></div>
                    </div>
                  </a>
                </div>
              </div>

              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-green">
                    <span class="cardsHb-rate">
                      <img src="/account/img/cards/rate-ico.svg" alt="" />
                      100
                    </span>
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Test name</span>
                      <span class="cardsHb-subtitle">Mrs. Name</span>
                      <div class="cardsHb-time">
                        <img src="/account/img/cards/img-6.svg" alt="" />
                        <span>30 min</span>
                      </div>
                    </div>
                    <div class="cardsHb-circle">
                      99%
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-green3">
                    <span class="cardsHb-rate">
                      <img src="/account/img/cards/rate-ico.svg" alt="" />
                      8
                    </span>
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Test name</span>
                      <span class="cardsHb-subtitle">Mrs. Name</span>
                      <div class="cardsHb-time">
                        <img src="/account/img/cards/img-6.svg" alt="" />
                        <span>33 min</span>
                      </div>
                    </div>
                    <div class="cardsHb-circle">
                      22%
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-green4">
                    <span class="cardsHb-rate">
                      <img src="/account/img/cards/rate-ico.svg" alt="" />
                      44
                    </span>
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Test name</span>
                      <span class="cardsHb-subtitle">Mrs. Name</span>
                      <div class="cardsHb-time">
                        <img src="/account/img/cards/img-6.svg" alt="" />
                        <span>33 min</span>
                      </div>
                    </div>
                    <div class="cardsHb-circle">
                      56%
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-blue2">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Test name</span>
                      <span class="cardsHb-subtitle">Practithink</span>
                      <div class="cardsHb-img"><img src="/account/img/cards/img-7.svg" alt="" /></div>
                    </div>
                    <div class="cardsHb-circle">
                      10
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-blue">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Practices name</span>
                      <span class="cardsHb-subtitle">Practithink</span>
                      <div class="cardsHb-img"><img src="/account/img/cards/img-2.svg" alt="" /></div>
                    </div>
                    <div class="cardsHb-circle">
                      <div class="cardsHb-ico"><img src="/account/img/cards/ico-2.svg" alt="" /></div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-blue">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Test name</span>
                      <span class="cardsHb-subtitle">Practithink</span>
                      <div class="cardsHb-time">
                        <img src="/account/img/cards/img-3.svg" alt="" />
                        <span>1 pm</span>
                      </div>
                    </div>
                    <div class="cardsHb-circle">
                      <div class="cardsHb-ico"><img src="/account/img/cards/ico-2.svg" alt="" /></div>
                    </div>
                  </a>
                </div>
              </div>
*/}
              {/* <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-blue">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Beyond Z</span>
                      <span class="cardsHb-subtitle">Practithink</span>
                      <div class="cardsHb-img"><img src="/account/img/cards/img-4.svg" alt="" /></div>
                    </div>
                    <div class="cardsHb-circle">
                      <div class="cardsHb-ico"><img src="/account/img/cards/ico-2.svg" alt="" /></div>
                    </div>
                  </a>
                </div>
              </div> */}

              {/* <div class="col-md-6">
                <div class="cardsHb-wrap">
                  <a href="#" class="cardsHb-item cardsHb-purple">
                    <div class="cardsHb-info">
                      <span class="cardsHb-title">Today’s checklist</span>
                      <span class="cardsHb-subtitle"></span>
                      <div class="cardsHb-img"><img src="/account/img/cards/img-8.svg" alt="" /></div>
                    </div>
                    <div class="cardsHb-of">
                      <span>12</span>/12
                    </div>
                  </a>
                </div>
              </div> */}

              <div className="col-md-6">
                <div className="cardsHb-wrap">
                  <Link
                    to={routes.timetable.day(curDate)}
                    class="cardsHb-item cardsHb-purple"
                  >
                    <div className="cardsHb-info">
                      <span className="cardsHb-title">Today’s checklist</span>
                      <div className="cardsHb-checkbox">
                        {events.length > 0 ? (
                          events.slice(0, 3).map((x) => (
                            <div key={x.id} className="cardsHb-check">
                              {x.status === 1 ? (
                                <img
                                  src="/account/img/cards/check-no.svg"
                                  alt=""
                                />
                              ) : (
                                <img
                                  src="/account/img/cards/check-ico.svg"
                                  alt=""
                                />
                              )}
                              {x.title}
                            </div>
                          ))
                        ) : (
                          <div className="white-label">
                            Get organized, set your goals for just today and a
                            week ahead
                          </div>
                        )}
                      </div>
                      {events.length > 3 && (
                        <span className="cardsHb-more">
                          +{events.length - 3} more{' '}
                        </span>
                      )}
                    </div>
                    <div className="cardsHb-of">
                      <span>{events.filter((x) => x.status === 2).length}</span>
                      /{events.length}
                    </div>
                  </Link>
                </div>
              </div>

              <div className="col-md-6">
                <div className="cardsHb-wrap">
                  <a
                    href={`${HOST}/practices/subjects`}
                    className="cardsHb-item cardsHb-orange"
                  >
                    <div className="cardsHb-info">
                      <span className="cardsHb-title">Practices catalog</span>
                      <span className="cardsHb-subtitle">Self-prep</span>
                      <div className="cardsHb-img">
                        <img src="/account/img/cards/img-5.svg" alt="" />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
